import { Section } from '@readycircle/ui';

export function PlanFreshness() {
  return (
    <Section
      eyebrow="Kept current"
      title="Plans go stale. ReadyCircle is built to keep yours current."
      description="As stations join or leave a Circle, roles change, or goals shift, your plan reflects that -- instead of becoming a document nobody trusts by the time an outage actually happens."
    />
  );
}
